import {colors} from '../styles';
import {ColorScheme, colorScheme} from '../util/colorScheme';

interface Options {
  backgroundColor: string;
}

const colorSchemeMap: Record<ColorScheme, Options> = {
  dark: {
    backgroundColor: colors.black,
  },
  light: {
    backgroundColor: colors.white,
  },
};

export const screenColorScheme = colorSchemeMap[colorScheme];
